namespace $ {

	// Preserve the original memoized method before installing the global policy.
	// Editors opt into native lazy rendering without changing other lists.
	export const $shm_list_sub_visible = $.$$.$mol_list.prototype.sub_visible

	export function $shm_list_virtualization_disable() {
		$.$$.$mol_list.prototype.sub_visible = function() {
			return this.sub() as $mol_view[]
		}
	}

	$shm_list_virtualization_disable()

}
